// Blog posts data - Add more posts here

export const blogPosts = [
  {
    id: 1,
    slug: 'how-to-choose-perfect-sofa',
    title: 'How to Choose the Perfect Sofa for Your Living Room',
    excerpt: 'Discover key factors to consider when selecting a sofa that matches your style, space, and budget.',
    content: `
      <p>Choosing the right sofa is one of the most important decisions when furnishing your living room.</p>
      <h2>1. Measure Your Space</h2>
      <p>Before falling in love with a sofa, measure your room carefully.</p>
      <h2>2. Consider Your Lifestyle</h2>
      <p>Choose durable, stain-resistant fabrics if you have kids or pets.</p>
      <h2>3. Test the Comfort</h2>
      <p>Test seat depth, back support, and cushion firmness.</p>
    `,
    category: 'Buying Guides',
    author: 'Sky Furniture Team',
    date: '2024-01-15',
    image: '/images/blog/sofa-guide.jpg',
    readTime: '5 min read'
  },
  {
    id: 2,
    slug: 'small-space-furniture-tips',
    title: '10 Smart Furniture Solutions for Small Spaces',
    excerpt: 'Maximize your small apartment with clever furniture choices.',
    content: `
      <p>Living in a small space doesn't mean sacrificing style or comfort.</p>
      <h2>Multi-Functional Pieces</h2>
      <p>Choose furniture that serves multiple purposes.</p>
      <h2>Vertical Storage</h2>
      <p>Use wall space for shelving and storage.</p>
    `,
    category: 'Design Tips',
    author: 'Sky Furniture Team',
    date: '2024-01-10',
    image: '/images/blog/small-space.jpg',
    readTime: '7 min read'
  },
  {
    id: 3,
    slug: 'furniture-care-guide',
    title: 'Ultimate Furniture Care & Maintenance Guide',
    excerpt: 'Keep your furniture looking new for years.',
    content: `
      <p>Proper care extends furniture life significantly.</p>
      <h2>Wood Furniture</h2>
      <p>Dust regularly and use wood polish monthly.</p>
      <h2>Upholstery Care</h2>
      <p>Vacuum weekly and treat stains immediately.</p>
    `,
    category: 'Care & Maintenance',
    author: 'Sky Furniture Team',
    date: '2024-01-05',
    image: '/images/blog/care-guide.jpg',
    readTime: '6 min read'
  },
  {
    id: 4,
    slug: 'how-to-choose-dresser-size',
    title: 'How to Choose the Right Dresser Size for Your Bedroom',
    excerpt: 'The wrong dresser size crowds your room or leaves you short on storage. Here is how to get it right the first time.',
    content: `
      <p>A dresser is one of the hardest-working pieces in your bedroom — but only if it's the right size. Too wide and it swallows the room; too small and you're folding clothes into piles on the bed. Here's a practical way to choose.</p>
      <h2>1. Start With Your Wall, Not the Dresser</h2>
      <p>Measure the wall where the dresser will go, then subtract at least 90 cm (36 inches) for walking space in front. A good rule: the dresser should occupy no more than two-thirds of the wall's width. In a typical 3.5 m bedroom wall, that means a dresser up to about 150–160 cm wide.</p>
      <h2>2. Count Drawers by What You Actually Own</h2>
      <p>As a rough guide: everyday clothes need about 4–6 drawers per person, and bulky winter knits need deeper drawers. A 6-drawer dresser suits most couples; if you're storing for the whole family, step up to an 8 or 10-drawer model rather than buying a second small unit.</p>
      <h2>3. Depth Matters More Than You Think</h2>
      <p>Standard dressers are 40–50 cm deep. That's enough for folded clothes but tight for bulky Ontario winter sweaters. If your wardrobe is mostly knits and hoodies, prioritize deeper drawers over extra width.</p>
      <h2>4. When a Tall Chest Beats a Wide Dresser</h2>
      <p>Short on floor space? A tall chest of drawers gives you the same storage in half the footprint. Chests are ideal for narrow bedrooms, condo corners, and anywhere a wide dresser would block a doorway or window.</p>
      <h2>5. Check Height Against Your Mirror and Bed</h2>
      <p>If you plan to hang a mirror above the dresser, keep the combined height comfortable — the mirror's centre should sit near eye level. And leave visual breathing room: a dresser noticeably lower than your headboard looks anchored; one that towers over the bed looks crowded.</p>
      <p><strong>Bottom line:</strong> measure the wall, count your drawers honestly, and choose depth for winter clothes. Browse our <a href="/categories/dressers">dresser collection</a> or compact <a href="/categories/chest-dressers">chest of drawers</a> options, all available with <a href="/ontario">delivery across Ontario</a>.</p>
    `,
    category: 'Buying Guides',
    author: 'Sky Furniture Team',
    date: '2026-10-05',
    image: '/images/products/Dressers/10dd/10-Drawer-Double-Dresser.webp',
    readTime: '6 min read'
  },
  {
    id: 5,
    slug: 'small-bedroom-storage-toronto-condos',
    title: 'Small Bedroom Storage Ideas for Toronto Condos',
    excerpt: 'Condo bedrooms in Toronto average under 10 m². These storage ideas are built for exactly that reality.',
    content: `
      <p>The average Toronto condo bedroom is smaller than the walk-in closet it replaced. But small doesn't have to mean cluttered — it just means every piece has to earn its footprint. Here are storage ideas designed for real condo dimensions.</p>
      <h2>1. Go Tall, Not Wide</h2>
      <p>A 5-drawer chest occupies roughly 0.4 m² of floor but stores as much as a wide dresser. In a 3 m × 3 m bedroom, that's the difference between walking space and an obstacle course.</p>
      <h2>2. Choose Nightstands With Drawers</h2>
      <p>A nightstand isn't just a lamp holder — a 2 or 3-drawer nightstand adds serious storage for chargers, books, and bedside essentials without taking extra floor space.</p>
      <h2>3. Use the Wall Above the Dresser</h2>
      <p>A dresser topped with a mirror doubles as a vanity and bounces light around a small room, making it feel bigger. Wall-mounted shelves above free the dresser top entirely.</p>
      <h2>4. Under-Bed Storage Beats a Bigger Dresser</h2>
      <p>Platform beds with built-in drawers hide an entire dresser's worth of off-season clothes. If your bed has clearance, low-profile rolling bins work too.</p>
      <h2>5. One Wardrobe, Double Duty</h2>
      <p>A narrow 2-door wardrobe with interior drawers handles hanging clothes and folded items in one footprint — ideal when there's no room for both a wardrobe and a dresser.</p>
      <h2>6. Corner Space Isn't Wasted Space</h2>
      <p>A tall, narrow chest fits corners that can't hold anything else. Measure diagonally — many condo corners swallow a 45 cm-wide chest with room to spare.</p>
      <h2>7. Seasonal Rotation</h2>
      <p>Toronto wardrobes work twice as hard: summer linens and winter bulk. Store off-season clothes in vacuum bags under the bed and keep only the current season in drawers.</p>
      <h2>8. Mirrors Create the Illusion of Space</h2>
      <p>A full-length mirror on a wardrobe door or a framed mirror over the dresser visually doubles a small bedroom. It's the cheapest square footage you'll ever "add."</p>
      <h2>9. Buy for the Room You Have</h2>
      <p>Tape the footprint on your floor before ordering. If the taped outline leaves less than 75 cm of walking space, size down — a slightly smaller piece you can walk around beats a bigger one you can't.</p>
      <p><strong>Bottom line:</strong> in a condo, vertical storage wins. Explore compact <a href="/categories/chest-dressers">chests of drawers</a> and <a href="/categories/sidetables">storage nightstands</a> with <a href="/ontario/toronto">furniture delivery in Toronto</a> and across the GTA.</p>
    `,
    category: 'Design Tips',
    author: 'Sky Furniture Team',
    date: '2026-10-12',
    image: '/images/products/Chest%20Drawers/3cd/Dark-Walnut-3-Drawer-Chest.webp',
    readTime: '7 min read'
  },
  {
    id: 6,
    slug: 'wooden-bed-frame-vs-upholstered',
    title: 'Wooden Bed Frames vs Upholstered Beds: Which Lasts Longer?',
    excerpt: 'Both look great on day one. Here is how they compare after five years of real life.',
    content: `
      <p>A bed frame is a 10-year purchase — or it should be. The wooden vs upholstered debate usually comes down to looks, but durability, maintenance, and daily comfort matter more. Here's an honest comparison.</p>
      <h2>Durability: Wood Wins on Lifespan</h2>
      <p>A solid wooden frame — especially hardwood or engineered wood with proper joinery — routinely lasts 10–15 years. It doesn't sag, the finish can be refreshed, and individual parts (slats, legs) are replaceable. Upholstered frames last 5–8 years on average before foam compresses or fabric shows wear.</p>
      <h2>Maintenance: Wood Is Nearly Effortless</h2>
      <p>Wood needs an occasional wipe-down. Upholstered headboards collect dust, absorb odours, and show stains — a real consideration if you eat breakfast in bed or have pets that claim the pillows.</p>
      <h2>Comfort: Upholstered Has One Advantage</h2>
      <p>Reading or watching TV in bed? A padded headboard is genuinely more comfortable to lean against than hard wood. If that's your nightly routine, it's a point for upholstery — or add oversized pillows to a wooden headboard.</p>
      <h2>Style and Versatility</h2>
      <p>Upholstered beds lean modern and soft; wooden frames range from rustic to mid-century to minimalist. Wood also re-styles easily — change bedding and it looks new; re-styling an upholstered bed usually means reupholstering it.</p>
      <h2>Cost Over Time</h2>
      <p>Upholstered frames often cost more upfront and need replacing sooner. A quality wooden frame typically costs less per year of use — the best value in the bedroom.</p>
      <h2>The Verdict</h2>
      <p>Choose wood if you want the longest-lasting, lowest-maintenance frame. Choose upholstered if nightly reading comfort outweighs everything else. Either way, pair it with a supportive <a href="/categories/mattresses">mattress</a> — the frame holds you up, but the mattress is what you feel.</p>
      <p>Browse our <a href="/categories/wooden-beds">wooden bed frames</a>, including storage platform beds that add drawer space to smaller bedrooms.</p>
    `,
    category: 'Buying Guides',
    author: 'Sky Furniture Team',
    date: '2026-10-19',
    image: '/images/products/Wooden%20Beds/DB/Dark-Brown-Wooden-Bed.webp',
    readTime: '6 min read'
  },
  {
    id: 7,
    slug: 'guest-room-holiday-essentials',
    title: 'Get Your Guest Room Holiday-Ready: 7 Furniture Essentials',
    excerpt: 'Holiday guests are coming. These seven pieces turn a spare room into a place people actually enjoy sleeping in.',
    content: `
      <p>Holiday hosting season is weeks away, and the guest room is usually the last room anyone thinks about — until guests arrive. You don't need a full renovation; these seven essentials cover everything a visitor needs.</p>
      <h2>1. A Real Bed, Not an Air Mattress</h2>
      <p>Nothing says "we prepared for you" like a proper bed with a decent <a href="/categories/mattresses">mattress</a>. Guests remember bad sleep longer than they remember dinner.</p>
      <h2>2. Nightstands on at Least One Side</h2>
      <p>A <a href="/categories/sidetables">nightstand</a> with a drawer holds a phone charger, water glass, and reading glasses — the three things every guest reaches for at night. Two is ideal; one is non-negotiable.</p>
      <h2>3. Somewhere to Put a Suitcase</h2>
      <p>Guests shouldn't live out of a bag on the floor. A low bench, a small chest, or even clear dresser drawers give them a proper landing zone for their things.</p>
      <h2>4. A Mirror</h2>
      <p>A <a href="/categories/dresser-mirrors">dresser mirror</a> serves double duty: guests can get ready without queuing for the bathroom, and it makes a small spare room feel twice as big.</p>
      <h2>5. Extra Bedding Within Reach</h2>
      <p>Ontario nights get cold fast in December. Store a spare blanket and pillow in the room itself — guests won't ask at midnight, they'll just shiver.</p>
      <h2>6. A Reading Light</h2>
      <p>Overhead lighting is harsh at 11 pm. A small lamp on the nightstand is one of the cheapest upgrades with the biggest comfort payoff.</p>
      <h2>7. Empty Drawer or Shelf Space</h2>
      <p>Clear one drawer and a bit of closet rod. It signals "this room is yours for the stay" more than any welcome basket.</p>
      <p><strong>Bottom line:</strong> a comfortable guest room is about thoughtfulness, not square footage. Stock up on the essentials with <a href="/ontario">delivery across Ontario</a> — order by early December to beat the holiday rush.</p>
    `,
    category: 'Design Tips',
    author: 'Sky Furniture Team',
    date: '2026-10-26',
    image: '/images/products/Sidetables/ST/Charcoal-Grey-2-drawer-sidetable.jpg',
    readTime: '6 min read'
  },
  {
    id: 8,
    slug: 'wardrobe-organization-ontario-winter',
    title: 'Wardrobe Organization for Ontario Winters: Storing Coats, Boots & Bulk',
    excerpt: 'A parka takes the space of ten shirts. Here is how to make your wardrobe survive an Ontario winter.',
    content: `
      <p>Ontario winter doesn't just change your wardrobe — it doubles its volume. Parkas, snow pants, heavy knits, and boots demand a completely different storage strategy than summer. Here's how to set up a wardrobe that handles it.</p>
      <h2>1. Zone by Frequency, Not by Type</h2>
      <p>Daily winter gear (coat, boots, scarf) belongs at grab height near the door or in the most accessible wardrobe section. Occasional items (ski pants, formal coats) go up high or to the back. You'll open the daily zone 10× more — design for it.</p>
      <h2>2. Give Bulk Its Own Space</h2>
      <p>Don't wedge a parka between blazers; it crushes everything. Dedicate one full wardrobe section — or a deep <a href="/categories/chest-dressers">chest drawer</a> — to bulky knits and fleece. Folded knits in deep drawers stay loftier than crammed hanging ones.</p>
      <h2>3. Boots Need a Home, Not a Pile</h2>
      <p>A boot tray or the wardrobe's bottom shelf keeps salty slush off floors and keeps pairs together. Tall boots store best upright with shapers; short boots can go on a low shelf two-high.</p>
      <h2>4. Drawers Beat Shelves for Winter Accessories</h2>
      <p>Gloves, hats, and scarves vanish on shelves. Shallow drawers — or drawer dividers in a <a href="/categories/wardrobes">wardrobe with built-in drawers</a> — keep every pair findable on a dark January morning.</p>
      <h2>5. Rotate, Don't Cram</h2>
      <p>The single biggest win: move summer clothes out. Vacuum bags under the bed or in a spare closet free 30–40% of wardrobe space. Your winter gear finally fits, and summer clothes stay fresh.</p>
      <h2>6. Leave Breathing Room</h2>
      <p>A wardrobe packed tight wrinkles wool and traps moisture. If you can't slide hangers freely, you need more storage, not better folding. A 3 or 4-door wardrobe gives winter the volume it demands.</p>
      <p><strong>Bottom line:</strong> winter storage is a volume problem, solved by zones, drawers, and rotation. Explore <a href="/categories/wardrobes">wardrobes with drawer options</a> in 2 to 6-door sizes, with <a href="/ontario">delivery across Ontario</a>.</p>
    `,
    category: 'Design Tips',
    author: 'Sky Furniture Team',
    date: '2026-11-02',
    image: '/images/products/Wardrobes/10dw/Luxury-White-10-Door-Wardrobe.webp',
    readTime: '6 min read'
  },
  {
    id: 9,
    slug: 'chest-of-drawers-vs-dresser',
    title: "Chest of Drawers vs Dresser: What's the Difference?",
    excerpt: 'People use the names interchangeably, but the furniture is different — and one of them fits your room better.',
    content: `
      <p>Ask five people the difference between a chest of drawers and a dresser and you'll get five shrugs. Retailers don't help — the terms get swapped constantly. Here's the real distinction and why it matters when you're buying.</p>
      <h2>The Core Difference: Shape</h2>
      <p>A <strong>chest of drawers</strong> is tall and narrow — typically 3 to 6 drawers stacked vertically in a footprint around 80–100 cm wide. A <strong>dresser</strong> is short and wide — usually 4 to 12 drawers in two or three columns, around 130–170 cm wide. Same storage idea, opposite proportions.</p>
      <h2>Storage Capacity: Roughly Equal, Differently Arranged</h2>
      <p>A 5-drawer chest and a 6-drawer dresser hold similar volumes. The chest stacks it vertically (great for folded clothes); the dresser spreads it horizontally (easier to see everything at once). Deep drawers in either handle bulky knits.</p>
      <h2>Room Fit: This Is the Deciding Factor</h2>
      <p><strong>Choose a chest</strong> when floor space is tight: condo bedrooms, narrow walls, rooms where a wide dresser would block a door swing or window. <strong>Choose a dresser</strong> when you have a long empty wall and want a surface on top — for a TV, a mirror, or décor.</p>
      <h2>The Top Surface Test</h2>
      <p>A dresser's wide top is genuinely useful — it doubles as a changing table, entryway console, or vanity with a mirror. A chest's narrow top fits a lamp and a plant, little more. If you need surface area, that's your answer.</p>
      <h2>Price and Value</h2>
      <p>Per drawer, chests are often slightly cheaper (less material, simpler build). But the real value question is fit: the wrong piece — however cheap — is money wasted if it crowds the room.</p>
      <h2>Quick Decision Guide</h2>
      <p>Narrow room or tight wall? → <a href="/categories/chest-dressers">Chest of drawers</a>. Long wall and want a usable top? → <a href="/categories/dressers">Dresser</a>. Still unsure? Tape both footprints on your floor — the right one is obvious in 30 seconds.</p>
    `,
    category: 'Buying Guides',
    author: 'Sky Furniture Team',
    date: '2026-11-09',
    image: '/images/products/Chest%20Drawers/3cd/Light-Oak-3-Drawer-Chest.webp',
    readTime: '5 min read'
  },
  {
    id: 10,
    slug: 'mattress-guide-cold-sleepers',
    title: 'Mattress Buying Guide for Cold Sleepers',
    excerpt: 'If you sleep cold, your mattress choice matters more than your blanket. Here is what actually keeps you warm.',
    content: `
      <p>Cold sleepers know the drill: socks in bed, blanket pulled to the chin, still chilly at 3 am. Before blaming the furnace, look at your mattress — some sleep noticeably warmer than others, and the difference is built into the materials.</p>
      <h2>Why Some Mattresses Sleep Warmer</h2>
      <p>Warmth comes down to airflow and heat retention. Dense foams trap body heat; open coil systems let it escape. Neither is "better" — it's about matching the mattress to the sleeper.</p>
      <h2>Memory Foam: Warmest Option</h2>
      <p>Memory foam contours closely, which reduces airflow and holds warmth — exactly what cold sleepers want. A <a href="/categories/mattresses">memory foam mattress</a> is the warmest-sleeping mainstream choice, ideal from October through April in Ontario.</p>
      <h2>Hybrid: The Balanced Middle</h2>
      <p>Hybrids pair foam comfort layers with a coil base, so they sleep warmer than pure innerspring but cooler than all-foam. Good if you sleep cold in winter but warm in summer — or if your partner sleeps hot.</p>
      <h2>Latex and Innerspring: Coolest Sleep</h2>
      <p>Natural latex and traditional innersprings breathe the most. Great for hot sleepers; cold sleepers should only choose these with a warm mattress topper or heated bedding plan.</p>
      <h2>Firmness Matters Too</h2>
      <p>Softer mattresses let you sink in, increasing body contact and warmth. Cold sleepers often do better on the medium to medium-soft side — provided spinal support stays correct for their sleep position.</p>
      <h2>What to Pair It With</h2>
      <p>A warm-sleeping mattress plus flannel sheets and a duvet with the right tog rating beats any single "warm" product alone. And check the base: solid platform <a href="/categories/wooden-beds">bed frames</a> block cold air from below better than open slats in a drafty room.</p>
      <p><strong>Bottom line:</strong> cold sleeper? Start with memory foam, go medium-soft, and layer your bedding. Your January self will thank you.</p>
    `,
    category: 'Buying Guides',
    author: 'Sky Furniture Team',
    date: '2026-11-16',
    image: '/images/products/Queen_bed/img1.jpeg',
    readTime: '6 min read'
  },
  {
    id: 11,
    slug: 'bedroom-furniture-year-end-buying-guide',
    title: '5 Bedroom Furniture Pieces Worth Buying Before Year-End',
    excerpt: "If you're buying bedroom furniture once this year, make it count. These five pieces give the biggest comfort and storage return.",
    content: `
      <p>Year-end is the natural moment to fix the bedroom — you'll spend more time indoors over the next four months than any other stretch of the year. If the budget covers five pieces, these deliver the biggest difference per dollar.</p>
      <h2>1. The Dresser That Actually Fits</h2>
      <p>Most bedrooms have the wrong dresser — too big for the wall or too small for the clothes. Measure once (see our <a href="/blog/how-to-choose-dresser-size">dresser size guide</a>) and buy the <a href="/categories/dressers">dresser</a> that matches your wall and your drawer count. It's the room's visual anchor.</p>
      <h2>2. A Wardrobe With Room to Grow</h2>
      <p>Winter gear proved it: you need more hanging and drawer space than you think. A <a href="/categories/wardrobes">wardrobe</a> in the next size up — 3 doors instead of 2, drawers included — ends the seasonal storage shuffle for good.</p>
      <h2>3. A Bed Frame Built for a Decade</h2>
      <p>The frame is the foundation everything else sits on. A solid <a href="/categories/wooden-beds">wooden bed frame</a> outlasts trends and cheaper builds, and storage platform beds add drawer space small rooms desperately need.</p>
      <h2>4. Nightstands With Drawers</h2>
      <p>The most underrated piece in the bedroom. <a href="/categories/sidetables">Nightstands with drawers</a> clear clutter off every surface and keep essentials within arm's reach — a small purchase with daily payoff.</p>
      <h2>5. A Mattress Matched to How You Sleep</h2>
      <p>Cold sleeper? Back pain? The <a href="/categories/mattresses">right mattress</a> changes how you feel every single morning. Of all five pieces, this one affects your life most directly — don't let it be an afterthought.</p>
      <h2>Buy in the Right Order</h2>
      <p>Bed and mattress first (sleep), then dresser and wardrobe (storage), then nightstands (finishing touch). Spreading the cost across November and December works — just order early enough to beat holiday delivery crunches.</p>
    `,
    category: 'Buying Guides',
    author: 'Sky Furniture Team',
    date: '2026-11-23',
    image: '/images/products/Dressers/10dd/10-Drawer-Charcoal-Gray-Dresser.webp',
    readTime: '7 min read'
  },
];

export const categories = ['All', 'Buying Guides', 'Design Tips', 'Care & Maintenance', 'Trends'];

// Weekly drip: a post becomes visible only once its date has arrived (local
// time, same local-parse convention used for display). Future-dated posts are
// hidden from the listing, return "not found" on direct visit, and are kept
// out of the sitemap until their publish date.
export const isPostPublished = (post) => {
  if (!post || !post.date) return true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(`${post.date}T00:00:00`) <= today;
};

export const publishedPosts = blogPosts.filter(isPostPublished);

export default blogPosts;